import React from 'react'

import * as S from './styled'

export type ArticleListSectionProps = {
  title: string
}
export const SectionTitle = ({ title }: ArticleListSectionProps) => {
  return <S.Container>{title}</S.Container>
}
